import { DataRestoreProcess } from "../../../SyncService/index";
import { LanguageContext } from "../../../context/LanguageContext";
import { useEffect, useState, useContext } from "react";
import { setCurrentScreen } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import {
  getLangFromAsyncStorage,
  setLangInAsyncStorage,
} from "../../../constants/index";
import { useAuthContext } from "../../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, LinearProgress } from "@mui/material";
import { DotsLoader, HeaderRupin, ImageRingLoader } from "../../common";
import { ParagraphText } from "../../../Libraries";
import { ULogo } from "../../../assets/icons/icon";
import { handleApi } from "../../../apis";
import { POST_LOGOUT } from "../../../apis/configuration";
import styles from "./styles.module.css";
import { clearLocalStorageExcludeSomeFields } from "../../../utils";

const DataRestore = () => {
  const { user, setBusiness } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const [progressComplete, setProgressComplete] = useState(false);
  const [I18n, changeLanguage] = useContext(LanguageContext);
  const [toast_Loading, setToastLoad] = useState(false);
  const [error_toast, setToastEror] = useState("");

  const phoneNumber = location?.state?.phone || ""; 

  useEffect(() => {
    setCurrentScreen(analytics, "Data_restore_screen");
    if (user && user.is_active) {
      restoreData();
    } else {
      navigate("/", {
        replace: true,
        state: { fromLogin: true },
      });
    }
  }, []);

  const restoreData = () => {
    const lastVisited = localStorage.getItem("lastVisited")
    try {
      if (navigator.onLine) {
        DataRestoreProcess(user, navigate)
          .then(async () => {
            triggerLogEvent(analytics, "data_sync_from_cloud_success", {});

            setProgressComplete(true);

            if (user.is_active) {
              const activeBusiness = await user.activeBusiness.fetch();

              activeBusiness[0] &&
                activeBusiness[0].id &&
                localStorage.setItem("business_id", activeBusiness[0].id);
              if (activeBusiness.length) {
                setBusiness(activeBusiness[0]);
                localStorage.setItem("phone_number", phoneNumber);
                navigate("/BusinessOverview");
              } else {
                let allBusiness = await user.business.fetch();

                allBusiness[0] &&
                  allBusiness[0].id &&
                  localStorage.setItem("business_id", allBusiness[0].id);

                if (allBusiness.length) {
                  let business = allBusiness[0];
                  business.activateBusiness().then(() => {
                    setBusiness(business);
                    localStorage.setItem("phone_number", phoneNumber);
                    navigate("/BusinessOverview");
                  });
                } else {
                }
              }
            } else {
              navigate("/", {
                replace: true,
                state: {
                  fromLogin: true,
                },
              });
            }
          })
          .catch((error) => {

            Logout();
            triggerLogEvent(analytics, "data_sync_from_cloud_fail", {});

            if (error?.message && error?.message === "Timeout") {
              setToastEror(I18n.timeout_message);
              setToastLoad(true);
              handleToast();
            } else {
              navigate("/SignUp");
              setToastEror(I18n.timeout_message);
              setToastLoad(true);
              handleToast();
            }
          });
      }
    } catch (e) { }
  };

  const Exit = () => {
    clearLocalStorageExcludeSomeFields()
    navigate("/", {
      replace: true,
    });
  };

  const Logout = () => {
    try {
      if (navigator.onLine) {
        handleApi(POST_LOGOUT, null, null, navigate).finally(() => {
          getLangFromAsyncStorage()
            .then((language) => {
              setLangInAsyncStorage(language);
              if (user.is_active) {
                user
                  .deactivateUser()
                  .then(() => {
                    Exit();
                  })
                  .catch((e) => { });
              } else {
                Exit();
              }
            })
            .catch((e) => { });
        });
      }
    } catch (e) { }
  };

  const handleToast = () => {
    let timer = setTimeout(() => {
      setToastLoad(false);
    }, 2000);
    return () => clearTimeout(timer);
  };

  return (
    <Box className={styles.restoreYourDataContainer}>
      <Box className={styles.restoreYourDataInner}>
        <DotsLoader message={`${I18n.secured_data_transmission_in_progress}`} />
      </Box>
    </Box>
  );
};

export default DataRestore;
